import axios from "../../axios-config";

export const getAllModules = async () => {
    const response = await axios.get(`/professoru/v1/modules`);
    return response?.data || [];
};

const mergeContentResponses = (responses) => {
    const seen = new Set();
    const data = [];

    responses.forEach((response) => {
        (response?.data || []).forEach((item) => {
            if (!item?._id || seen.has(item._id)) return;
            seen.add(item._id);
            data.push(item);
        });
    });

    return { data, pagination: responses[0]?.pagination || {} };
};

export const getAllContents = async (params = {}) => {
    if (Array.isArray(params.type) && params.type.length > 1) {
        const responses = await Promise.all(
            params.type.map(async (type) => {
                const response = await axios.get(`/professoru/v1/content`, {
                    params: { ...params, type },
                });
                return response?.data || { data: [], pagination: {} };
            })
        );
        return mergeContentResponses(responses);
    }

    const requestParams = Array.isArray(params.type)
        ? { ...params, type: params.type[0] }
        : params;
    const response = await axios.get(`/professoru/v1/content`, { params: requestParams });
    return response?.data || { data: [], pagination: {} };
};

export const getContentById = async (id) => {
    const response = await axios.get(`/professoru/v1/content/${id}`);
    return response?.data || [];
};

export const getContentsByModule = async (id) => {
    const response = await axios.get(`/professoru/v1/content/module/${id}`);
    return response?.data || [];
};

export const searchGuidesAndTroubleshooting = async (params = {}) => {
    const response = await axios.get(`/professoru/v1/content/guides/search`, { params });
    return response?.data || { data: [], pagination: {} };
};